import { createQueryClient } from '@frontend/profilum-components';

export const queryClient = createQueryClient();
